










import { Vue, Component, Prop } from 'vue-property-decorator';
import { MessageDialog } from '../../../utils/MessageDialog';
import { dayjs, DTW_FORMAT_JA, DT_FORMAT_JA, T_FORMAT_JA, DTW_FORMAT_JA_WO_YM } from '../../../../src_server/common/momentExtends';
import { ScheduledLessonsDTO } from '../../../../src_server/entity/dto/ScheduledLessonsDTO';
import { StudentService } from '../../../biz/remote/StudentService';
import { Session } from '../../../utils/Session';
import { DaLessonsService } from '../../../biz/remote/DaLessonsService';

@Component({ components: {} })
export default class DaReservationAddSection extends Vue {
  @Prop({ default: new ScheduledLessonsDTO() })
  private dto!: ScheduledLessonsDTO;

  private studentsOptions: { value: string; title: string }[] = [];

  /**
   * 生徒の確定予約を追加
   */
  private add_student_id = '';
  private get studentName() {
    return '';
  }

  /**
   * 開始時間のプロパティ
   */
  private add_start_time = '';

  /**
   * 終了時間のプロパティ
   */
  private add_end_time = '';

  /**
   * 追加ボタン
   */
  async addReservedUser() {
    const user = this.studentsOptions.find((s) => s.value === this.add_student_id);
    const isOK = await MessageDialog.confirm(`${user?.title}さんの${this.add_start_time}-${this.add_end_time}の予約を追加します。よろしいですか？`);
    if (isOK) {
      const biz = new DaLessonsService();
      const start = this.add_start_time.split(':');
      const start_h = parseInt(start[0]);
      const start_m = parseInt(start[1]);
      const end = this.add_end_time.split(':');
      const end_h = parseInt(end[0]);
      const end_m = parseInt(end[1]);

      const start_dt = dayjs(`${this.dto.shift_table.start_time}`).set('hours', start_h).set('minute', start_m).toDate();
      const end_dt = dayjs(`${this.dto.shift_table.end_time}`).set('hours', end_h).set('minute', end_m).toDate();
      const response = await biz.reservation(this.add_student_id, this.dto.teacher.user_id!, start_dt, end_dt, this.dto.shift_table.shift_table_id!, false);
      const addedReserve = response.data;
      await MessageDialog.alert(`${user?.title}さんの${this.add_start_time}-${this.add_end_time}の予約を追加しました`);
      this.$emit('added', addedReserve);
    }
  }

  async created() {
    const biz = new StudentService();
    const response = await biz.getAllStudentInBuilding(Session.getSessionBuildingId());
    this.studentsOptions = response.data.map((s) => {
      return { value: s.user_id!, title: s.user_name! };
    });
    this.add_start_time = dayjs(this.dto.shift_table.start_time).format('HH:mm');
    this.add_end_time = dayjs(this.dto.shift_table.end_time).format('HH:mm');
  }
}
